import { Inbox, ArrowLeft, Calendar, Clock, TrendingUp, Mail, AlertTriangle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/Badge";

export const GmailPromotionsHeroSection = () => {
  const navigate = useNavigate();

  const stats = [
    { value: "68.8%", label: "of Gmail users check Promotions", source: "Validity 2024" },
    { value: "19.2%", label: "avg open rate in Promotions", source: "Mailchimp 2024" },
    { value: "22.8%", label: "avg open rate in Primary", source: "Return Path" },
    { value: "~45%", label: "of marketing emails go to Promotions", source: "Litmus 2024" },
  ];

  return (
    <section className="pt-6 sm:pt-8 md:pt-10 pb-8 sm:pb-10 md:pb-12">
      {/* Back Button */}
      <button
        onClick={() => navigate("/")}
        className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-6 group"
      >
        <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
        <span className="text-sm font-medium">Back to Insights</span>
      </button>

      {/* Tag */}
      <Badge className="mb-4">Gmail Algorithm</Badge>

      {/* Title */}
      <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-foreground leading-tight mb-4">
        Understanding Gmail's Promotions Tab Algorithm
      </h1>

      {/* Subtitle */}
      <p className="text-lg sm:text-xl text-muted-foreground mb-6 max-w-3xl">
        Why your emails land in Promotions instead of Primary, and evidence-based strategies to improve inbox placement
      </p>

      {/* Meta info */}
      <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground mb-8">
        <div className="flex items-center gap-1.5">
          <Calendar className="w-4 h-4" />
          <span>January 2025</span>
        </div>
        <div className="flex items-center gap-1.5">
          <Clock className="w-4 h-4" />
          <span>7 min read</span>
        </div>
      </div>

      {/* Key Stats */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
        {stats.map((stat, index) => (
          <div key={index} className="bg-card border border-border rounded-xl p-4">
            <div className="text-2xl font-bold text-primary mb-1">{stat.value}</div>
            <div className="text-xs text-muted-foreground mb-2">{stat.label}</div>
            <div className="text-xs text-muted-foreground/60">{stat.source}</div>
          </div>
        ))}
      </div>

      {/* Data sources note */}
      <p className="text-xs text-muted-foreground/60 mt-4">
        Data compiled from Validity Email Deliverability Benchmark 2024, Mailchimp Email Marketing Benchmarks, 
        Return Path Inbox Placement Report, and Litmus State of Email 2024.
      </p>
    </section>
  );
};
